import React from 'react';
import styles from './Footer.scss';
import { Text, TextButton, Tooltip } from 'wix-style-react';
import { TranslationFunction } from 'react-i18next';

export interface FooterProps {
  t: TranslationFunction;
}

export const Footer: React.FC<FooterProps> = ({ t }) => {
  function TooltipContent() {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: t('WHAT_DOES_THIS_MEAN_TOOLTIP') }}
      />
    );
  }

  return (
    <div className={styles.footer}>
      <Text>{t('FEATURES_NOT_RESTORED')}</Text>
      <Tooltip content={<TooltipContent />} fixed maxWidth={400}>
        <TextButton>{t('WHAT_DOES_THIS_MEAN_LABEL')}</TextButton>
      </Tooltip>
    </div>
  );
};
